export default "__VITE_ASSET__0fa0qw2P__"